import api from "./axios";

export const pending_expenses = () => api.get(`/user/v2/expense/pending`);
export const ttc_expenses = () => api.get(`/user/v2/textToConfirmExpenses`);
export const remove_text_to_confirm = (expense_id) => api.delete(`/expense/v2/${expense_id}/textToConfirm`);
export const get_profile = () => api.get(`/user/v2/profile`);
export const get_profile_all_plans = () => api.get(`/user/v2/profile?allPlans=true`);
export const update_user_profile = (payload) => api.patch(`/user/v2/profile`, payload);
export const change_email = (payload) => api.post(`/user/email`, payload);
export const change_password = (payload) => api.post(`/user/password`, payload);
export const get_user_insurances = (config) => api.get(`/user/insurance`, config);
export const get_users = (config) => api.get(`/user/v2`, config);
export const send_message = (payload) => api.post(`/send/webContact`, payload);
export const get_user_documents = () => api.get(`/user/v2/profile/documents`);
export const create_account = (payload) => api.post(`/user/createAccount`, payload);
export const create_referral_account = (payload) => api.post(`/user/createReferralAccount`, payload);
export const create_partner_account = (payload) => api.post(`/user/createPartnerAccount`, payload);
export const create_user_referral_account = () => api.post(`/user/v2/createReferralAccount`);
export const resend_account_email = (employer_id, payload) => api.post(`/user/${employer_id}/resendAccountEmail`, payload);
export const get_user_from_token = (token) => api.get(`/user/profile`, { params: { token } });
export const set_onboarding_details = (userPlanId, payload) => api.post(`/user/plan/onboarding/details/${userPlanId}`,payload);
export const delete_user = (userId) => api.delete(`/user/v2/${userId}`);
export const get_claims = (paramsString) => api.get(`/user/v2/expenseReimbursements?${paramsString}`);
export const get_user_approved_expenses_report = (config) =>
  api.get(`/user/v2/reports/approved-expenses`, config);
export const get_user_expense_transactions_report = (config) =>
  api.get(`/user/v2/reports/expense-transactions`, config);
export const get_user_account_activity_report = (config) =>
  api.get(`/user/v2/reports/account-activity`, config);
